import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import ConfirmationDialogComponent from './confirmation-dialog.component';

@Injectable()
export default class ConfirmationDialogService {
  constructor(private modalService: NgbModal) {}

  public confirm(
    title: string,
    message: string,
    btnOkText: string,
    btnCancelText: string,
    dialogSize: 'sm' | 'lg' = 'sm',
    hideButtons?: boolean,
    timeoutOnShow?: boolean,
    isError?: boolean,
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.hideButtons = hideButtons;
    modalRef.componentInstance.timeoutOnShow = timeoutOnShow;
    modalRef.componentInstance.isError = isError;

    return modalRef.result;
  }
}
